import React, { useState, useEffect, useRef } from 'react';

interface Props {
  pageName: string // cookieの干渉を避けるためにページ名を入れる
  inputName: string
  errorCheck: IErrorCheck
  checkList: ICheckListItem[]
  pcNowrap: boolean
}

interface ICheckListItem {
  id: string,
  name: string,
}

interface IErrorCheck {
  (): void
}

interface IHandleCheck {
  (event: React.ChangeEvent<HTMLInputElement>): void
}

const Checkbox = ({ id, name, value, checked, onChange }: { id: string, name: string, value: string, checked: boolean, onChange: IHandleCheck }) => {
  return (
    <input
      id={id}
      type="checkbox"
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      className={`c-formItem__checkbox ${checked === false ? '' : 'checked'} ga-${name}`}
    />
  )
}

export const CheckboxList = (props: Props) => {
  const [checkedList, setCheckedList] = useState<string[]>([])
  const isChangedValue = useRef(false) // 画面描画後から一度でも値が変更されたことがあるかをチェックするフラグ

  useEffect(() => {
    // cookieに格納されている props.inputName の値を初期化する
    document.cookie = `${props.pageName}-${props.inputName}=; max-age=0; path=/`
    document.cookie = `${props.pageName}-${props.inputName}DisplayName=; max-age=0; path=/`
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let updatedList = [...checkedList]
    if (event.target.checked) {
      updatedList = [...checkedList, event.target.value]
    } else {
      updatedList.splice(checkedList.indexOf(event.target.value), 1)
    }
    setCheckedList(updatedList)

    const sortedList = updatedList.sort()
    // NOTE: フォームの入力値はcookie経由でバックエンドAPIに送信するため、配列型の値はJSON文字列に変換した値をcookieに設定する
    document.cookie = `${props.pageName}-${props.inputName}=${JSON.stringify(sortedList)}; max-age=172800; path=/`
    const displayName = convertToDisplayName(sortedList)
    document.cookie = `${props.pageName}-${props.inputName}DisplayName=${encodeURIComponent(displayName)}; max-age=172800; path=/`

    props.errorCheck()

    isChangedValue.current = true
  }

  const convertToDisplayName = (updatedList: string[]) => {
    const checkedCheckList = props.checkList.filter((i) => updatedList.includes(i.id))
    const displayNameList = checkedCheckList.map((i) => i.name)
    return displayNameList.join(', ')
  }

  const isError = checkedList.length === 0 && isChangedValue.current

  return (
    <>
      <div className={`c-contact__cols ${props.pcNowrap ? 'contact__cols--pc-nowrap' : ''}`}>
        {props.checkList.map((checkListItem, index) => (
          <div
            className={`c-contact__col c-contact__col--checkboxListItem ${props.pcNowrap ? 'c-contact__col--checkboxListItem-pc-nowrap' : ''}`}
            key={index}
          >
            <Checkbox
              id={`id_${index}`}
              value={checkListItem.id}
              name={props.inputName}
              onChange={handleChange}
              checked={checkedList.includes(checkListItem.id)}
            />
            <label
              htmlFor={`id_${index}`}
              className="c-formItem__label c-formItem__label--checkboxListItem -hasChedkbox"
            >
              {checkListItem.name}
            </label>
          </div>
        ))}
      </div>

      {isError ? <p className="c-contact__errorMessage">必須項目です</p> : <></>}
    </>
  )
}
